export default __webpack_public_path__ + "static/media/trophy.ec0cb004.svg";